module.exports = __webpack_public_path__ + "static/media/Giving.0e1ceb5e.png";